import { pg_tileserv_url } from "../../../utils";

const DensidadPoblacion = {
    enable: true,
    checked: false,
    initialDisplay: false,
    excludeCities: [],
    source: "pg_tileserv",
    url: pg_tileserv_url + "REPLACECITYNAME.densidad_poblacion",
    zindex: 3,
    type: "single",
    popup: {
        default: {
            content: {
                es: {},
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.DensidadPoblacion",
    style: {
        regular: false,
        fillColor: "rgb(0, 0, 0)",
        strokeColor: "rgb(0, 0, 0)",
        strokeWidth: 0,
        strokeLineDash: [],
        points: 0,
        radius: 1,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.DensidadPoblacion.title",
            subtitle: "",
            attribute: "",
            symbol: "point",
            legendCustomCssClass: "map-legend-symbol-5px",
            class: [
                {
                    fillColor: "rgb(0, 0, 0)",
                    strokeColor: "rgb(0, 0, 0)",
                    strokeWidth: 0,
                    label: "Mobility Indicators Content.layersLegend.DensidadPoblacion.classes.1",
                },
            ],
        },
    },
};

export default DensidadPoblacion;
